import { render, staticRenderFns } from "./inventory-forecast.vue?vue&type=template&id=0ef04548&scoped=true"
import script from "./inventory-forecast.vue?vue&type=script&lang=js"
export * from "./inventory-forecast.vue?vue&type=script&lang=js"
import style0 from "./inventory-forecast.vue?vue&type=style&index=0&id=0ef04548&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef04548",
  null
  
)

export default component.exports